// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setAuthInfo: (state: IRootState, action: PayloadAction<IRootState['auth_info']>) => ({
    ...state,
    auth_info: action.payload,
  }),
  setProfileInfo: (state: IRootState, action: PayloadAction<IRootState['profile_info']>) => ({
    ...state,
    profile_info: action.payload,
  }),
  setBiometricData: (state: IRootState, action: PayloadAction<IRootState['biometric_data_info']>) => ({
    ...state,
    biometric_data_info: action.payload,
  }),
  resetProfileInfo: () => initialState,
};

export { reducers };
